<default-popup-wrapper-component [componentRef]="this" [globalPopup]="globalPopup"
                                 [displayMode]="POPUP_DISPLAY_MODE.XLARGE"
                                 [title]="'filter.advanced' | translate" (onClose)="closePopup($event)">

    <div class="row">
        <div class="col-12 col-md-4 table-options-settings-container">
            <div class="dynamic-form mb-4">
                <h2 class="py-0">{{ts.translate('optionset.smart-filters.title')}}</h2>
                <div class="intro-text">{{'optionset.pickpreset' | translate}}</div>
                <div class="drag-container">
                    <div class="inner-drag-container-top">
                        <div class="drag-item d-flex align-items-center justify-content-between locked" (click)="handleAddOptionSet()">
                            <div class="d-flex align-items-center">
                                <i class="material-icons p-0 mr-2">add_circle</i>
                                <span>{{ts.translate('optionset.saveselectionas')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="inner-drag-container">
                        <div
                            #dragContainer
                            cdkDropList
                            [cdkDropListData]="tableOptionSets"
                            (cdkDropListDropped)="onRankChange($event)"
                        >
                            <div cdkDrag
                                 *ngFor="let item of tableOptionSets; let index = index;"
                                 (click)="handleSelectOptionSet(item.id)"
                                 [cdkDragBoundary]="dragContainer"
                                 [ngClass]="{'show-as-tab':item.showAsTab, 'active':selectedOptionsSetId===item.id }"
                                 class="drag-item d-flex align-items-center justify-content-between"
                            >
                                <div class="d-flex align-items-center">
                                    <i class="material-icons drag-icon" cdkDragHandle>drag_indicator</i>
                                    <span>{{ item.name }}</span>
                                </div>
                                <div class="d-flex align-items-center justify-content-end">
                                    <i class="material-icons p-0" *ngIf="item.isGlobal" [title]="ts.translate('optionset.global-tab-info')">supervised_user_circle</i>
                                    <i class="material-icons p-0"
                                       (click)="toggleOptionsDropdown(item,$event)"
                                    >more_vert</i>
                                    <div class="dropdown" [ngClass]="{'show':item.showOptionsDropdown, 'dropup':(tableOptionSets.length > 7 && index > tableOptionSets.length-4)}">
                                        <div class="dropdown-menu smart-selection-dropdown dropdown-menu-right">
                                            <ul class="mb-0">
                                                <li class="d-flex align-items-center p-1" *ngIf="canEditTab(item)" (click)="handleEditOptionSet(item.id,$event)">
                                                    <i class="material-icons p-0 mr-1">save</i>
                                                    <span>Selectie updaten</span>
                                                </li>
                                                <li class="p-1" (click)="toggleItemOnTab(item,$event)">
                                                    <span class="d-flex align-items-center" *ngIf="!item.showAsTab">
                                                        <i class="material-icons p-0 mr-1">tab</i>
                                                        <span>{{ts.translate('optionset.tab-options.addtotab')}}</span>
                                                    </span>
                                                    <span class="d-flex align-items-center" *ngIf="item.showAsTab">
                                                        <i class="material-icons p-0 mr-1">tab_unselected</i>
                                                        <span>{{ts.translate('optionset.tab-options.removefromtab')}}</span>
                                                    </span>
                                                </li>


                                                <li class="p-1" *ngIf="auth.allowGlobalTab()" (click)="toggleItemGlobal(item,$event)">
                                                    <span class="d-flex align-items-center" *ngIf="!item.isGlobal">
                                                        <i class="material-icons p-0 mr-1">supervised_user_circle</i>
                                                        <span>{{ts.translate('optionset.tab-options.setglobal')}}</span>
                                                    </span>
                                                    <span class="d-flex align-items-center" *ngIf="item.isGlobal">
                                                        <i class="material-icons p-0 mr-1">account_circle</i>
                                                        <span>{{ts.translate('optionset.tab-options.removeglobal')}}</span>
                                                    </span>
                                                </li>

                                                <li class="d-flex align-items-center p-1" *ngIf="canEditTab(item)" (click)="handleRenameOptionSet(item,$event)">
                                                    <i class="material-icons p-0 mr-1">edit</i>
                                                    <span>{{ts.translate('optionset.renametitle')}}</span>
                                                </li>
                                                <li class="d-flex align-items-center p-1" *ngIf="canEditTab(item)" (click)="handleDeleteOptionSet(item,$event)">
                                                    <i class="material-icons p-0 mr-1">clear</i>
                                                    {{ts.translate('optionset.deletetitle')}}
                                                    <span></span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <i class="material-icons p-0">keyboard_arrow_right</i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="table-options-settings-container col-12 col-md-8 {{loadingSet?'no-pointer-events':''}}">
            <div *ngIf="auth.allowShowArchived()" class="dynamic-form mb-4">
                <h2>{{'filter.archive' | translate}}</h2>
                <div class="d-flex">
                    <form-component-label
                            [config]="{
                            label:ts.translate('filter.archived'),
                            attr:{infoText:ts.translate('filter.archivedinfo')}
                        }">
                    </form-component-label>
                    <label class="custom-control m-0 mb-1 ml-1 custom-checkbox w-100">
                        <input type="checkbox" class="custom-control-input"
                               checked="{{tempShowArchived?'checked':''}}" (change)="handleChangeArchived()"/>
                        <span class="custom-control-indicator" style="min-width:25px; min-height:25px;"></span>
                    </label>
                </div>
            </div>
            <div class="dynamic-form">
                <table-column-selector #columnSelectorComponent
                                       [allowAddFilters]="true"
                                       [allowToggleOnMap]="!hideMap"
                                       [allowSorting]="false"
                                       [tableFields]="tableFields"
                                       (onChanges)="onColumnChange()"
                                       (onUserClick)="setUserClick()">
                </table-column-selector>
            </div>

        </div>
    </div>
    <div class="">
        <div class="temp-save-btn d-flex align-items-center justify-content-end">
            <lumi-button (onClick)="saveCurrentFilter()"
                         [icon]="'save'"
                         [size]="'small'"
                         [rank]="'input'"
                         [disabled]="buttonSaveSelectionDisabled"
                         [label]="ts.translate('optionset.save')"></lumi-button>
        </div>
    </div>
</default-popup-wrapper-component>

